var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.2,
    height: 14.2,
    viewBox: "0 0 14.2 14.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documents",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28813",
    "data-name": "Path 28813",
    d: "M22.7,12.652h-2.13V9.3a.3.3,0,0,0-.3-.3H9.3a.3.3,0,0,0-.3.3V21.478A1.523,1.523,0,0,0,10.522,23H21.478A1.523,1.523,0,0,0,23,21.478V12.957A.3.3,0,0,0,22.7,12.652ZM10.522,22.391a.914.914,0,0,1-.913-.913V9.609H19.957v11.87a1.516,1.516,0,0,0,.3.913Zm11.87-.913a.913.913,0,1,1-1.826,0V13.261h1.826Z",
    transform: "translate(-9 -9)",
    fill: "#474461",
    stroke: "#474461",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28814",
    "data-name": "Path 28814",
    d: "M23.391,17H17.3a.3.3,0,0,0-.3.3v2.435a.3.3,0,0,0,.3.3h6.087a.3.3,0,0,0,.3-.3V17.3A.3.3,0,0,0,23.391,17Zm-.3,2.435H17.609V17.609h5.478Z",
    transform: "translate(-14.565 -14.565)",
    fill: "#474461",
    stroke: "#474461",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28815",
    "data-name": "Path 28815",
    d: "M23.391,33H17.3a.3.3,0,1,0,0,.609h6.087a.3.3,0,1,0,0-.609Z",
    transform: "translate(-14.565 -25.696)",
    fill: "#474461",
    stroke: "#474461",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28816",
    "data-name": "Path 28816",
    d: "M23.391,39H17.3a.3.3,0,0,0,0,.609h6.087a.3.3,0,0,0,0-.609Z",
    transform: "translate(-14.565 -29.87)",
    fill: "#474461",
    stroke: "#474461",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28817",
    "data-name": "Path 28817",
    d: "M23.391,45H17.3a.3.3,0,1,0,0,.609h6.087a.3.3,0,1,0,0-.609Z",
    transform: "translate(-14.565 -34.043)",
    fill: "#474461",
    stroke: "#474461",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.0208102d81b153f61fa82aaa08c900a4.svg";
export { ForwardRef as ReactComponent };